(function ($) {
    /**
     * parse params from url
     * @param str
     * @returns {{}}
     */
    function parseParams(str) {
        return str.split('&').reduce(function (params, param) {
            var paramSplit = param.split('=').map(function (value) {
                return decodeURIComponent(value.replace(/\+/g, ' '));
            });
            params[paramSplit[0]] = paramSplit[1];
            return params;
        }, {});
    }

    /**
     * Simple debounce
     * @param delay
     * @param fn
     * @returns {Function}
     */
    function debounced(delay, fn) {
        let timerId;
        return function (...args) {
            if (timerId) {
                clearTimeout(timerId);
            }
            timerId = setTimeout(() => {
                fn(...args);
                timerId = null;
            }, delay);
        }
    }

    /**
     * Ajax call with retry
     * @param url
     * @param params
     * @param cb
     */
    function ajaxWithRetry(url, params, cb) {
        function innerCall(retry) {
            $.get(url, params, cb)
                .fail(function () {
                    if (retry > 0) {
                        innerCall(retry - 1);
                    }
                });
        }

        innerCall(5);
    }

    "use strict";
    $(function () {
        var filterForms = $(".done_awesome_filter_form");
        if (filterForms.length === 0) {
            return;
        }

        // for each form handle the submit ourselves

        filterForms.each(function (i, form) {
            // load form options
            var formOptions = $(form).data('options');
            // to keep it future save, set all default values here
            formOptions = Object.assign({
                use_ajax: false,
                ajax_url: '',
                has_clearall: false,
                clearall_ajax_url: ''
            }, formOptions);

            if (!formOptions.use_ajax) {
                $(form).parents('.done__filter_wrapper').find('.done__filter_order select').on('change', function () {
                    $(form).submit();
                });
            }


            function hookClearAllAjax() {
                var clearallDiv = $(form).parents('.done__filter_wrapper');
                if (clearallDiv.length !== 1) {
                    alert('Cannot find .done__filter_wrapper as a parent of the ajax filter form!');
                    return;
                }
                clearallDiv = clearallDiv.find('.done__clearallblock');
                if (clearallDiv.length !== 1) {
                    alert('Cannot find .done__clearallblock inside .done__filter_wrapper for the ajax filter form!');
                    return;
                }

                clearallDiv.find("a").each(function (i, item) {
                    $(item).unbind('click').on('click', function (e) {
                        e.preventDefault();
                        var formParams = parseParams($(this).attr('href').substr(1));

                        $(form).find('input[type=radio],input[type=checkbox]').prop('checked', false);
                        $(form).find('select:not(.SumoUnder),input[type=text]').val('');
                        $(form).find('input[type=radio]').each(function (i, radio) {
                            if ($(radio).val() == '') {
                                $(radio).prop('checked', true);
                            }
                        });


                        Object.keys(formParams).forEach(function (key) {
                            if (!key) {
                                return;
                            }
                            // for text inputs / selects
                            $(form).find("input[type=text][name=" + key + "],select:not(.SumoUnder)[name=" + key + "]").val(formParams[key]);

                            // for checkboxes and radios
                            var taxvalue = formParams[key].split("-");
                            $(form).find("input[type=checkbox][name=" + key + "],input[type=radio][name=" + key + "]").each(function (i, j) {
                                if (taxvalue.indexOf($(j).val()) !== -1) {
                                    $(j).prop('checked', true);
                                }
                            });
                        });

                        // sumo select magic
                        var $sliders = $(form).find('.js-done-range-slider');

                        $.each($sliders, function (i, el) {

                            var needvalue = formParams[$(el).next().prop('name')] || '';

                            if (needvalue == '') {
                                $($sliders)[i].noUiSlider.set([parseInt($(el).data('min')), parseInt($(el).data('max'))]);
                                $(el).parent().removeClass('slider-active');
                            }

                        });

                        $(form).find('.SumoUnder').each(function (i, j) {

                            if (!j.sumo) {
                                return;
                            }


                            var needvalue = formParams[$(j).prop('name')] || '';

                            if ($(j).hasClass('done__multiple-select')) {
                                j.sumo.unSelectAll();
                                var needvalue = needvalue.split("-");
                                $(needvalue).each(function (i, v) {
                                    j.sumo.selectItem(v);
                                });

                            } else {

                                j.sumo.unSelectAll();

                                $(j).children().map((i, option) => {
                                    if ($(option).val() + "" == needvalue + '') {
                                        if (needvalue == "") {
                                            $(j).parent().find('.options li').eq(0).addClass('selected');
                                        }
                                        j.sumo.selectItem(i);
                                    }
                                });
                            }


                        });


                        if (done_awesome_filter_localize.done_enable_animations) {
                            $('.done__filter_results').animate({ opacity: 0 }, 200, 'linear', function () {
                                $('.js-done-result-loader').fadeIn(200, function () {
                                    ajaxLoadHandler(formParams);
                                });
                            });
                        } else {
                            ajaxLoadHandler(formParams);
                        }
                    });
                });
            }

            function ajaxLoadHandler(formFinalValues) {
                // add sortby if defined
                var sortbyDom = $(form).parents('.done__filter_wrapper');
                if (sortbyDom.length !== 1) {
                    alert('Cannot find .done__filter_wrapper as a parent of the ajax filter form!');
                    return;
                }
                sortbyDom = sortbyDom.find('.done__filter_order select');
                if (sortbyDom.length !== 1) {
                    alert('Cannot find .done__filter_order select inside .done__filter_wrapper for sorting!');
                    return;
                }

                if ($(sortbyDom).val() !== '') {
                    formFinalValues['orderby'] = $(sortbyDom).val();
                }

                var resultDiv = $(form).parents('.done__filter_wrapper');
                if (resultDiv.length !== 1) {
                    alert('Cannot find .done__filter_wrapper as a parent of the ajax filter form!');
                    return;
                }
                resultDiv = resultDiv.find('.done__filter_results');
                if (resultDiv.length !== 1) {
                    alert('Cannot find .done__filter_results inside .done__filter_wrapper for the ajax filter form!');
                    return;
                }

                // before the ajax call addClass .loading to done__filter_results
                resultDiv.addClass('loading');
                ajaxWithRetry(formOptions.ajax_url, $.param(formFinalValues), function (data) {

                    if (window.history && history.replaceState) {
                        window.history.replaceState(null, null, window.location.href.split('?')[0] + "?" + $.param(formFinalValues));
                    }
                    // add loaded class, so we can hide the 'jump' from replacing content
                    resultDiv.addClass('loaded');
                    var oldchildren = resultDiv.html('');
                    resultDiv.append(data);

                    resultDiv.removeClass('loaded');
                    resultDiv.removeClass('loading');

                    if (done_awesome_filter_localize.done_enable_animations) {
                        $('.js-done-result-loader').fadeOut(200, function () {
                            resultDiv.animate({ opacity: 1 }, 200)
                        });
                    }


                    // check for infinite scroll
                    setTimeout($.doneHookInfiniteScrollIndicators, 100);
                });

                if (formOptions.has_clearall) {
                    var clearallDiv = $(form).parents('.done__filter_wrapper');
                    if (clearallDiv.length !== 1) {
                        alert('Cannot find .done__filter_wrapper as a parent of the ajax filter form!');
                        return;
                    }
                    clearallDiv = clearallDiv.find('.done__clearallblock');
                    if (clearallDiv.length !== 1) {
                        alert('Cannot find .done__clearallblock inside .done__filter_wrapper for the ajax filter form!');
                        return;
                    }
                    clearallDiv.addClass('loading');
                    ajaxWithRetry(formOptions.clearall_ajax_url, $.param(formFinalValues), function (data) {
                        clearallDiv.replaceWith(data);
                        hookClearAllAjax();
                        clearallDiv.removeClass('loading');
                    });
                }


            }

            // hook clear alls
            if (formOptions.has_clearall && formOptions.use_ajax) {
                hookClearAllAjax();
            }

            // if we use ajax, hook all onchange with debounce
            if (formOptions.use_ajax) {
                var ajaxSubmitDebounce = debounced(300, function () {
                    formSubmitFunc();
                })
                $(form).parents('.done__filter_wrapper').find('.done__filter_order select').on('change', ajaxSubmitDebounce);

                var $sliders = $('.js-done-range-slider');

                $.each($sliders, function (i, el) {

                    /* Update value fields on change of handles */
                    $($sliders)[i].noUiSlider.on('change', function (values, handle) {
                        ajaxSubmitDebounce();
                    });
                });

                $(form).find("input,select").on('change keyup', function () {
                    if (!$(this).hasClass('search-txt')) {
                        ajaxSubmitDebounce();
                    }

                });
            }
            /**
             * This function gets called every time we change (if using ajax) / submit something
             * @returns {boolean}
             */
            var formSubmitFunc = function () {

                // collect checkboxes into one array
                var checkboxblocks = {};
                $(form).find("input[type=checkbox]").each(function (j, input) {
                    // ignore empty values and unchecked boxes


                    var val = $(input).val();

                    if (val != null || val != undefined) {
                        val = val.trim();
                    }
                    else {
                        val = '';
                    }


                    if ((val === '') || (!$(input).prop('checked'))) {
                        return;
                    }
                    // name
                    var name = $(input).attr('name');
                    if (!checkboxblocks[name]) {
                        checkboxblocks[name] = [];
                    }
                    checkboxblocks[name].push(val);

                    // remove name attr if we are not using ajax
                    if (!formOptions.use_ajax) {
                        $(input).removeAttr('name');
                    }
                });



                var rangeblocks = {};
                $(form).find(".done__range").each(function (j, input) {
                    // ignore empty values and unchecked boxes
                    var val = $(input).val();


                    if (!$(input).parent().hasClass('slider-active')) {
                        return;
                    }

                    if (val != null || val != undefined) {
                        val = val.trim();
                    }
                    else {
                        val = '';
                    }


                    if ((val === '')) {
                        return;
                    }

                    // name
                    var name = $(input).attr('name');
                    if (!rangeblocks[name]) {
                        rangeblocks[name] = [];
                    }
                    rangeblocks[name].push(val);

                    // remove name attr if we are not using ajax
                    if (!formOptions.use_ajax) {
                        $(input).removeAttr('name');
                    }
                });



                // collect multiple select into one array
                var multiselect = {};

                $(form).find('.done__multiple-select').each(function (j, input) {

                    var name = $(input).attr('name');
                    if (!multiselect[name]) {
                        multiselect[name] = [];
                    }
                    var $input_val = $(input).val();

                    if ($input_val) {
                        for (i = 0; i < $input_val.length; ++i) {
                            if (($input_val[i] === '')) {
                                return;
                            }
                            multiselect[name].push($input_val[i]);
                        }

                        // remove name attr if we are not using ajax
                        if (!formOptions.use_ajax) {
                            $(input).removeAttr('name');
                        }
                    }
                });


                // remove unused fields and add back checkboxes, if we do not use ajax
                if (!formOptions.use_ajax) {
                    // add back each checkbox block as hidden field
                    Object.keys(checkboxblocks).forEach(function (name) {
                        $(form).append($("<input type='hidden'/>").attr('name', name).val(checkboxblocks[name].join('-')));
                    });

                    Object.keys(rangeblocks).forEach(function (name) {
                        $(form).append($("<input type='hidden'/>").attr('name', name).val(rangeblocks[name].join(':')));
                    });

                    Object.keys(multiselect).forEach(function (name) {
                        $(form).append($("<input type='hidden'/>").attr('name', name).val(multiselect[name].join('-')));
                    });

                    // if we are doing a get, remove filter values with empty string
                    $(form).find("input,select:not(.done__multiple-select)").each(function (j, input) {

                        var inputval = $(input).val();

                        if (inputval != null || inputval != undefined) {
                            inputval = inputval.trim();
                        }
                        else {
                            inputval = '';
                        }

                        if (inputval === '') {
                            $(input).removeAttr('name');
                        }
                    });

                    // add sortby if defined
                    var sortbyDom = $(form).parents('.done__filter_wrapper');
                    if (sortbyDom.length !== 1) {
                        alert('Cannot find .done__filter_wrapper as a parent of the ajax filter form!');
                        return;
                    }
                    sortbyDom = sortbyDom.find('.done__filter_order select');
                    if (sortbyDom.length !== 1) {
                        alert('Cannot find .done__filter_order select inside .done__filter_wrapper for sorting!');
                        return;
                    }



                    if ($(sortbyDom).val() !== '' && $(sortbyDom).val() !== null && $(sortbyDom).val() !== undefined) {
                        $(form).append($("<input type='hidden'/>").attr('name', 'orderby').val($(sortbyDom).val()));
                    }

                    // allow the form to be submitted
                    return true;
                }

                // THIS IS THE AJAX PART
                var formRawValues = $(form).serializeArray();
                var formFinalValues = {};

                formRawValues.forEach(item => {
                    // do not submit empty stuff
                    if (item.value === '') {
                        return;
                    }
                    // for checkboxes we will use the grouped value
                    if (checkboxblocks[item['name']]) {
                        formFinalValues[item['name']] = checkboxblocks[item['name']].join('-');
                        return;
                    }

                    if ($(`input[name=${item.name}]`).hasClass('done__range')) {

                        if (!$(`input[name=${item.name}]`).parent().hasClass('slider-active')) {
                            return;
                        }
                    }

                    if (rangeblocks[item['name']]) {
                        formFinalValues[item['name']] = rangeblocks[item['name']].join(':');
                        return;
                    }

                    if (multiselect[item['name']]) {
                        formFinalValues[item['name']] = multiselect[item['name']].join('-');
                        return;
                    }

                    // everything else should be set as is
                    formFinalValues[item['name']] = item['value'];
                });



                if (done_awesome_filter_localize.done_enable_animations) {
                    $("html, body").stop().animate({ scrollTop: $('.done__filter_results').offset().top - 30 }, 500, 'swing', function () {
                        $('.done__filter_results').animate({ opacity: 0 }, 200, 'linear', function () {
                            $('.js-done-result-loader').fadeIn(200, function () {
                                ajaxLoadHandler(formFinalValues);
                            });
                        });
                    });
                } else {
                    ajaxLoadHandler(formFinalValues);
                }

                // do not submit form
                return false;
            }

            $(form).submit(formSubmitFunc);
        });
    });

})(jQuery);